export const VALIDATION_FIELD_CHANGE = 'VALIDATION_FIELD_CHANGE';
export const VALIDATION_SAVE = 'VALIDATION_SAVE';
export const VALIDATION_SAVE_PENDING = 'VALIDATION_SAVE_PENDING';
